import { useAddToCart } from "@/hooks/useCart";
import { useLike } from "@/hooks/useLike";
import { useMetaLikeAndComment } from "@/hooks/useMeta";
import useTranslation from "@/hooks/useTranslation";
import { currentUserState } from "@/stores/common";
import {
  HeartFilled,
  HeartOutlined,
  ReadOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import React from "react";
import { useRecoilValue } from "recoil";
import Citation from "./components/Citation";
import Download from "./components/Download";
import Export from "./components/Export";
import Share from "./components/Share";
import styles from "./styles.module.less";

const { itemContainer, itemIcon, itemText, tab } = styles;

interface IHelperProps {
  Icon: any;
  text: string | React.ReactNode;
  handleClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

const HelperItem: React.FC<IHelperProps> = (props) => {
  const { Icon, text, handleClick, disabled, loading } = props;
  return (
    <div className={itemContainer} onClick={disabled ? undefined : handleClick}>
      <div className={itemIcon}>{loading ? <SyncOutlined spin /> : Icon}</div>
      <div className={itemText}>{text}</div>
    </div>
  );
};

interface HelperProps {
  doi: string;
  pmid: string;
  articleTitle: string;
}

const Helper: React.FC<HelperProps> = ({ doi, pmid, articleTitle }) => {
  const { t } = useTranslation("explore");
  const { handleAddToCart, loading: loadingCart } = useAddToCart();
  const { handleLike: _handleLike, loading: loadingLike } = useLike(pmid);
  const { likedStatus, likedTimeCount } = useMetaLikeAndComment(pmid);
  const currentUser = useRecoilValue(currentUserState);

  const handleLike = () => _handleLike(`/navigator/paper/${pmid}`);

  return (
    <div className={tab}>
      <HelperItem
        Icon={<ReadOutlined />}
        text={t("tab.helper.fav")}
        handleClick={() => handleAddToCart(pmid)}
        loading={loadingCart}
        disabled={loadingCart || !currentUser.id}
      />
      <HelperItem
        Icon={likedStatus ? <HeartFilled /> : <HeartOutlined />}
        text={
          <span>
            {t("common:like")}
            <sup className={styles.color}>
              {likedTimeCount > 0 ? likedTimeCount : ""}
            </sup>
          </span>
        }
        handleClick={handleLike}
        disabled={loadingLike || !currentUser.id}
        loading={loadingLike}
      />
      <Download doi={doi} />
      <Share pmid={pmid} articleTitle={articleTitle} />
      <Export pmid={pmid} doi={doi} />
      <Citation doi={doi} />
    </div>
  );
};

export default Helper;
